import { getParameterByName, orgSearch } from '../helpers';
import { api } from './api';

export function getDetailedPathwayData(pathwayID, callback) {
  const uuid = pathwayID;
  const data = {
    uuid: uuid,
  };
  api.ibldmpathway.getPathway(data, function (data) {
    callback(data.body);
  });
}

export function pathwaySearchDataAPI(searchTerm, callback) {
  searchTerm = searchTerm.toLowerCase();
  if (searchTerm.length > 4) {
    const data =
      '?filter={"_index":"ibl-dm.public.dl_catalog_app_course"}&context=' +
      searchTerm;
    orgSearch(data, function (data) {
      callback(data.results);
    });
  }
}

export function createPathway(data, callback) {
  api.ibldmpathway.createPathway(data, function (data) {
    callback(data);
  });
}
